export default __webpack_public_path__ + "static/media/facebook.08d33b08.png";